import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

const KEY = 'svyaz_ui_visual_theme';

function isWeb(): boolean {
  return Platform.OS === 'web';
}

export async function readSavedVisualTheme(): Promise<string | null> {
  if (isWeb()) {
    try {
      if (typeof globalThis.localStorage === 'undefined') return null;
      return globalThis.localStorage.getItem(KEY);
    } catch {
      return null;
    }
  }
  try {
    return await EncryptedStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export async function writeSavedVisualTheme(value: string): Promise<void> {
  if (isWeb()) {
    try {
      globalThis.localStorage?.setItem(KEY, value);
    } catch {
      /* noop */
    }
    return;
  }
  try {
    await EncryptedStorage.setItem(KEY, value);
  } catch {
    /* noop */
  }
}
